import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IClientDetailsActions, IThunkUpdateTeam } from '../../types';

const onUpdateTeam: IThunkUpdateTeam = thunk(
  async ({ setClientDetails }: Actions<IClientDetailsActions>, payload) => {
    const { requestInfo, requestPayload: data } = payload;

    const { teamId, ...requestPayload } = data;

    const client = await api.clientTeams
      .updateTeam({ ...requestInfo, teamId: String(teamId) }, requestPayload)
      .then(r => r.data);

    setClientDetails({ actTeams: client.actTeams });

    return client.actTeams;
  },
);

export default onUpdateTeam;
